import ComplementaryRepository from "../../internals/repository/ComplementaryRepository";

const repo = new ComplementaryRepository();

export const ModuleEvents = {
  SET_SELECTED_SCREEN: "COMP_SET_SELECTED_SCREEN",
  FETCH_COMP_SUMMARY: "COMP_FETCH_COMP_SUMMARY",
  FETCH_COMP_AUDIT_LOG: "COMP_FETCH_COMP_AUDIT_LOG",
  FETCH_CONTACTS: "COMP_FETCH_CONTACTS",
  FETCH_COMP_TYPES: "COMP_FETCH_COMP_TYPES",
  SET_SELECTED_BATCH: "COMP_SET_SELECTED_BATCH",
};

const createAction =
  (type, action = () => {}, meta) =>
  (...args) => ({
    type,
    payload: action(...args),
    meta,
  });

const setSelectedScreen = createAction(
  ModuleEvents.SET_SELECTED_SCREEN,
  (screen) => screen,
);

const setSelectedBatch = createAction(
  ModuleEvents.SET_SELECTED_BATCH,
  (batchId) => batchId,
);

const fetchCompSummary = createAction(
  ModuleEvents.FETCH_COMP_SUMMARY,
  async (shopId, batchId) => {
    return repo.fetchCompSummaryByBatch(shopId, batchId);
  },
  { loading: true },
);

const fetchCompAuditLog = createAction(
  ModuleEvents.FETCH_COMP_AUDIT_LOG,
  async (shopId, batchId, limit = 200) => {
    return repo.fetchCompAuditLog(shopId, batchId, limit);
  },
  { loading: true },
);

const fetchContacts = createAction(
  ModuleEvents.FETCH_CONTACTS,
  async (shopId) => {
    return repo.fetchContacts(shopId);
  },
  { loading: true },
);

const fetchCompTypes = createAction(
  ModuleEvents.FETCH_COMP_TYPES,
  async (shopId) => {
    return repo.fetchCompTypes(shopId);
  },
  { loading: true },
);

const exportedFunctions = {
  setSelectedScreen,
  setSelectedBatch,
  fetchCompSummary,
  fetchCompAuditLog,
  fetchContacts,
  fetchCompTypes,
};

export default exportedFunctions;
